module.exports = __webpack_public_path__ + "img/ico-back.89f8d5d3.svg";